import React from 'react';
import './style.scss';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { HEADER_MENU, LOGOS } from '../../utils/consts';
import Certificates from '../certificates';
import ContactForm from '../contact-form';
import Logo from '../../images/svg/sn-logo.svg';
import { ToastContainer } from 'react-toastify';

function Footer() {
  const cpQuery = useStaticQuery(graphql`
    query {
      strapi {
        global {
          data {
            attributes {
              address
              googleMapsLink
              siteName
              facebookUrl
              instagramUrl
              linkedinUrl
            }
          }
        }
      }
    }
  `);
  const cpData = cpQuery.strapi.global.data.attributes;
  return (
    <footer className='container bg-primary z-50 relative w-full lg:h-[650px]'>
      <div className='w-full gap-40 items-center lg:h-full hidden lg:flex'>
        <div className='footer__left lg:gap-28 lg:h-full'>
          <div className='flex flex-col'>
            <Logo className='lg:w-[180px]' />
            <a
              className='p3 whitespace-pre-line lg:mt-20'
              href={cpData.googleMapsLink}
            >
              {cpData.address}
            </a>
            <Certificates />
            <div className='lg:mt-4'>
              <Link
                to='/terms-and-conditions'
                className='p3 block'
              >
                Terms & Conditions
              </Link>
              <Link
                to='/impressum-bh'
                className='p3 block'
              >
                Impressum BH
              </Link>
              <Link
                to='/impressum-hr'
                className='p3 block'
              >
                Impressum HR
              </Link>
            </div>
          </div>
          <div className='flex flex-col lg:gap-11 gap-4'>
            <div className='flex flex-col'>
              <h4 className='mb-3'>Menu</h4>
              {HEADER_MENU.map((menuItem) => (
                <Link
                  to={menuItem.path}
                  className='p3 capitalize'
                >
                  {menuItem.text}
                </Link>
              ))}
            </div>
            <div className='flex flex-col'>
              <h4 className='mb-3'>Socials</h4>
              <a
                href={cpData.linkedinUrl}
                className='p3'
              >
                LinkedIn
              </a>
              <a
                href={cpData.facebookUrl}
                className='p3'
              >
                Facebook
              </a>
              <a
                href={cpData.instagramUrl}
                className='p3'
              >
                Instagram
              </a>
            </div>
          </div>
        </div>
        <div className='footer__right'>
          <ContactForm />
        </div>
      </div>
      <div className='lg:hidden block'>
        <ContactForm />
        <div className='flex gap-4 items-center justify-center my-14'>
          <img
            src={LOGOS.logoWhite}
            alt='Logo'
            className='w-[75px]'
          />
          <Logo className='w-[190px]' />
        </div>
        <Certificates />
        <div className='flex justify-between mt-6 mb-9'>
          <a
            className='p3 whitespace-pre-line lg:mt-20'
            href={cpData.googleMapsLink}
          >
            {cpData.address}
          </a>
          <div className='lg:mt-4'>
            <Link
              to='/terms-and-conditions'
              className='p3 block'
            >
              Terms & Conditions
            </Link>
            <Link
              to='/impressum'
              className='p3'
            >
              Impressum BH
            </Link>
            <Link
              to='/impressum'
              className='p3'
            >
              Impressum HR
            </Link>
          </div>
        </div>
        <div className='flex flex-col lg:gap-11 gap-4'>
          <div className='flex flex-col'>
            <h4 className='mb-3'>Menu</h4>
            {HEADER_MENU.map((menuItem) => (
              <Link
                to={menuItem.path}
                className='p3 capitalize'
              >
                {menuItem.text}
              </Link>
            ))}
          </div>
          <div className='flex flex-col'>
            <h4 className='mb-3'>Socials</h4>
            <a
              href={cpData.linkedinUrl}
              className='p3'
            >
              LinkedIn
            </a>
            <a
              href={cpData.facebookUrl}
              className='p3'
            >
              Facebook
            </a>
            <a
              href={cpData.instagramUrl}
              className='p3'
            >
              Instagram
            </a>
          </div>
        </div>
      </div>
      <div className='lg:absolute block mt-24 mb-8 lg:bottom-11'>
        <p className='p3'>SocialNet Group all rights reserved, {new Date().getFullYear()}</p>
      </div>
      <ToastContainer />
    </footer>
  );
}

export default Footer;
